import { Box } from '../../../../common/ui/Box';
import { ScheduleLayout } from '../scheduleLayout';

import { ScheduleItem } from './ScheduleProductCard';

interface ScheduleBackgroundBarsProps {
    scheduleList: ScheduleItem[];
}

export const ScheduleBackgroundBars = ({ scheduleList }: ScheduleBackgroundBarsProps) => {
    return (
        <Box
            position="absolute"
            left={ScheduleLayout.BACKGROUND_LEFT_OFFSET}
            right="0"
            zIndex={0}
            display="flex"
            flexDirection="column"
            gap={ScheduleLayout.ROW_GAP}
        >
            <Box height={ScheduleLayout.HEADER_HEIGHT} display="flex" alignItems="center">
                <Box width="100%" height={ScheduleLayout.HEADER_BAR_HEIGHT} backgroundColor="background.inset" />
            </Box>

            {scheduleList.map((_, index) => (
                <Box key={index} height={ScheduleLayout.ROW_HEIGHT} display="flex" alignItems="center">
                    <Box width="100%" height={ScheduleLayout.ROW_BAR_HEIGHT} backgroundColor="background.inset" />
                </Box>
            ))}
        </Box>
    );
};
